import {HttpInterceptorFn} from '@angular/common/http';

export const ServiceInterceptor: HttpInterceptorFn = (request, next) => {
  try {
    if(new URL(request.url).hostname.includes('ca-rool.com'))
      return next(request.clone({ headers: request.headers.set('X-Service-Name', 'WebApp') }));
  } catch (_) {}
  return next(request);
}
